import store from "@/store";
import { dataProvider } from "@/@core/http";

export const getOrganizationResources = async () => {
  try {
    const organizationId = store.state.currentlyActiveOrganization.organization.id;
    const {
      data: { users: teammates, domains },
    } = await dataProvider.customHttpCall("GET", `organizations/${organizationId}/resources`);

    return Promise.resolve({
      teammates,
      domains,
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
